import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import cityBasicInformationPropTypes from '../proptypes/CityPropTypes';
import { Fragment } from 'react';
import InternalResource from '../../../../common/resource/InternalResource';
const CityBasicInformationResource = ({
  city
}) => (
  <Fragment>
    <ResourceProperty label="Name: ">{city.name || ''}</ResourceProperty>
    <ResourceProperty label="Región: ">
      {city.region ? city.region.name : ''}
    </ResourceProperty>
    <ResourceProperty label="País: ">
      {city.region ? city.region.country.name : ''}
    </ResourceProperty>
    <InternalResource
      id={city.id}
      lastUpdate={city.lastUpdate}
    />
  </Fragment>
);

CityBasicInformationResource.propTypes = cityBasicInformationPropTypes;

export default CityBasicInformationResource;
